import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecurringAvailableTractorList extends Layout {
    buttonCreateAvailableTractor: Button;
    dataheaderRecurringAvailableTractor: LayoutHeader;
    sourceRecurringAvailableTractor: DataSource;
    tableRecurringAvailableTractor: Table;
}
